<script>
export default {
}
</script>

<template>
  <nav>
    <div class="columns is-mobile">
      <div class="column">
        <img src="../assets/luna.png" class="brand" @click="$emit('clickBrand')">
      </div>
      <div class="column has-text-right">
        <b-button @click="$emit('logout')">Logout</b-button>
      </div>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
.brand {
  height: 36px;
  margin: 20px;
  margin-right: 0;
  margin-left: 15px;
  &:hover {
    background-color: whitesmoke;
    cursor: pointer;
  }
}
</style>